import _ from 'lodash'
import WidgetEmptyState from 'scoreboard/dashboards/widgets/widget-empty-state'
import conductor from 'scoreboard/components/conductor'
import getErrorMessage from 'scoreboard/datasets/not-available/get-error-message'
import Dataset from 'scoreboard/datasets/model/dataset'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * Handles errors for dataset table and dataset view widgets. this must be bound
 * to either dataset-value-widget-view.js or dataset-table-widget-view.js
 * @param {DatasetValueWidgetView|DatasetTableWidgetView} view
 * @param {Dataset} datasetModel the dataset in the widget.
 * @param {jQuery} container The jQuery-wrapped DOM node which will
 * 		be used for sizing and showing/hiding content appropriately
 * @param {'value'|'table'} widgetType
 * @param {ResolvableExceptionResponse} [errorResponse]
 */
function handleDatasetWidgetError(view, datasetModel,
	container, widgetType, errorResponse) {
	view._removeEmptyState()
	view.showResults(false)
	view.clearLoadingDots()

	view.widgetEmptyState = createDatasetEmptyState(datasetModel,
		view.container, widgetType, errorResponse)
	view.$('.empty-state-container').append(view.widgetEmptyState.el)
	view.widgetEmptyState.render()

	view.readyForDisplayAndExport()
}

/**
 * Creates an empty state for a dataset widget.
 * @param {Dataset} datasetModel the dataset in the widget.
 * @param {jQuery} container The jQuery-wrapped DOM node which will
 * 		be used for sizing and showing/hiding content appropriately
 * @param {('table'|'value')} widgetType
 * @param {ResolvableExceptionResponse} [errorResponse]
 * @return {WidgetEmptyState}
 */
function createDatasetEmptyState(datasetModel, container,
	widgetType, errorResponse) {

	let emptyStateOptions = _.extend(
		{ container, widgetType },
		getEmptyStateOptions({ datasetModel, errorResponse })
	)
	return new WidgetEmptyState(emptyStateOptions)
}

/**
 * Creates dataset-specific options for WidgetEmptyState
 *
 * @param {Dataset} datasetModel the dataset in the widget.
 * @param {ResolvableExceptionResponse} [errorResponse]
 * @return {Object}
 */
function getEmptyStateOptions ({ datasetModel, errorResponse }) {
	const dataset = unwrapModel(datasetModel)
	const emptyStateOpts = { errorResponse }
	if (!errorResponse) {
		// if the dataset is in ERROR state, and we didn't get an errorResponse
		// from the server for a query error, then display the dataset's errorMessage.
		if (dataset.status === Dataset.ERROR) {
			emptyStateOpts.message = getErrorMessage(datasetModel)
			emptyStateOpts.errorResponse = { messageCode: 'datasets.hasError' }
			emptyStateOpts.onClick = () => conductor.overview('datasets', dataset.id)
		// the datset is not in ERROR state, but we also didn't get an errorResponse
		// from the server, so just display a generic not ready message.
		} else {
			emptyStateOpts.errorResponse = { messageCode: 'datasets.notReady' }
		}
	}
	emptyStateOpts.icon = Dataset.widgetErrorIcon(emptyStateOpts.errorResponse.messageCode)
	return emptyStateOpts
}

export default handleDatasetWidgetError
export { getEmptyStateOptions }

handleDatasetWidgetError.__filename__ = 'dashboards/widgets/handle-dataset-widget-error.js'
